module.exports = __webpack_public_path__ + "static/media/manage.a036d0a6.svg";